import React from 'react';
import { useSliderContext } from './context';

function Footer() {
  const { min, max, valToString } = useSliderContext();
  return (
    <div className="mt-10 flex items-center text-sm text-black-gray">
      <div>{valToString(min)}</div>
      <div className="ml-auto">{valToString(max)}</div>
    </div>
  );
}

export default Footer;
